module.exports = "<!-- ================================================================================== -->\r\n<!-- TEXTO TIENDA -->\r\n<!-- ================================================================================== -->\r\n\r\n<section class=\"text__footer mb20\">\r\n\r\n    <div class=\"container\">\r\n        <div class=\"col-md-12\">\r\n            <span class=\"text-justify\"\r\n                  ng-bind-html=\"$ctrl.responseText | toTrusted\"></span>\r\n        </div>\r\n    </div>\r\n\r\n</section>";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/box-text-template/templates/box-text-template-base.html
 ** module id = 635
 ** module chunks = 0
 **/